import type { ReactNode } from 'react';

export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="state" role="status" aria-live="polite">
      <div className="spinner" />
      <span className="text-muted">{label}</span>
    </div>
  );
}

export function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="state error" role="alert">
      <div className="state-icon">⚠️</div>
      <h4>Something went wrong</h4>
      <p className="text-muted" style={{ maxWidth: 420 }}>
        {message}
      </p>
      {onRetry && (
        <button className="btn btn-secondary btn-sm" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}

export function Empty({
  icon = '📭',
  title = 'Nothing here yet',
  hint,
  action,
}: {
  icon?: string;
  title?: string;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <div className="state">
      <div className="state-icon">{icon}</div>
      <h4>{title}</h4>
      {hint && <p className="text-muted">{hint}</p>}
      {action}
    </div>
  );
}
